// @ts-nocheck
/* eslint-disable */
export const againIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 8 8"><path fill="currentColor" d="M3.833 7.673A3.84 3.84 0 0 1 0 3.84c0-.76.22-1.5.647-2.127a.504.504 0 0 1 .693-.14.504.504 0 0 1 .14.694 2.84 2.84 0 0 0 2.36 4.407A2.84 2.84 0 0 0 6.673 3.84 2.84 2.84 0 0 0 3.84 1.007q-.498 0-.967.14a.506.506 0 0 1-.626-.334.5.5 0 0 1 .333-.626A4.2 4.2 0 0 1 3.84 0a3.84 3.84 0 0 1 3.833 3.833 3.85 3.85 0 0 1-3.84 3.84"/></svg>`,
    name: 'again' as const
};